import { ODataSelect } from "../../../Providers.Api/ODataQuery";

export class VisitorType extends ODataSelect
{
    public VisitorTypeId = '';
    public Name = '';
}
